import Couchdb from 'src/services/Couchdb'
import { verifyEmptyTags, defineWhereObject } from 'src/services/DashboardCounter'
import { mapStates, mapActions, mapMutations, mapGetters } from './../baseModule'
import connections from 'src/config/connections'
import _ from 'lodash'
import moment from 'moment'

const collection = 'events'
const singleName = 'event'
const pluralName = 'events'

const statusOptions = {
  programado: { 'value': 0, 'label': 'Programado' },
  iniciado: { 'value': 1, 'label': 'Iniciado' },
  finalizado: { 'value': 2, 'label': 'Finalizado' }
}

const model = {
  city: '',
  reference: '',
  prizeLink: '',
  place: '',
  startDate: moment.utc(Date()).format(),
  endDate: moment.utc(Date()).format(),
  dateTimeCeremony: moment.utc(Date()).format(),
  dateTimeDelivery: moment.utc(Date()).format(),
  timeEndDelivery: '',
  numberOfRefigerators: Number(),
  numberOfLamps: Number(),
  status: 1,
  drawn: false,
  present: {},
  surveysType: ['refrigerator'],
  winnerChoiceMode: '',
  directList: false,
  energyDefaultWinner: true,
  registerCustomerByCsv: false,
  confirmCustomerByCsv: false,
  downloadWinnersCsv: false,
  downloadWinnersPpt: false,
  hasSortTRG_889: false,
  doc: {
    companyTerms: 'generic',
    deliveryAddress: '',
    daysToVisit: '04',
    registerCustomerTicketDocument: false
  },
  lamp: {
    powerLampDeliveryLabel: '8,5',
    requiredTermLamp: false
  }
}

const validations = {
  city: {
    required: true,
    min: 5
  },
  reference: {
    required: true,
    min: 5
  },
  place: {
    required: true,
    min: 5
  },
  startDate: {
    required: true
  },
  endDate: {
    required: true
  },
  dateTimeCeremony: {
    required: true
  },
  dateTimeDelivery: {
    required: true
  },
  numberOfRefigerators: {
    required: true,
    numeric: true
  },
  numberOfLamps: {
    numeric: true,
    required: true
  },
  status: {
    required: true
  },
  surveyTypes: { required: true },
  directList: { required: true }
}

let present = (one) => {
  let present = {}
  let status = _.find(statusOptions, obj => obj.value === one.status)
  present.status = status === undefined ? '' : status.label
  return present
}

const getters = {
  ...mapGetters(),
  surveysOptions: () => Object.assign({
    refrigerator: 'Refrigerador',
    diagnostic: 'Diagnóstico'
  }),
  statusOptions: state => statusOptions,
  loading: state => state.loading,
  validations: state => state.validations,
  count: state => state.count,
  startedOptions: state => {
    return state.all.filter(item => item.status && item.status === 1)
      .map(item => {
        return {
          value: item._id,
          label: `${item.reference} - ${item.place} - ${item.city}`
        }
      })
  },
  optionsById: state => {
    let options = [{ value: '', label: 'Selecione um evento' }]

    if (!state.all) {
      return options
    }

    state.all.map((item) => {
      options.push({
        value: item._id,
        label: `${item.reference} - ${item.city} - ${moment(item.startDate)
          .format('LLL')}`,
        place: item.place,
        status: item.status
      })
    })

    return options
  },
  allFiltered: state => state.allFiltered,
  ticketsCounter: state => state.ticketsCounter,
  lampsCounter: state => state.lampsCounter,
  sortedByReference: state => state.all.sort((a, b) => b.hasOwnProperty('reference') && a.hasOwnProperty('reference') ? (b.reference).localeCompare(a.reference) : 0)
}
getters[singleName] = state => {
  let one = Object.assign({}, model, state.one)
  one.startDate = new Date(one.startDate)
  one.endDate = new Date(one.endDate)
  one.dateTimeCeremony = new Date(one.dateTimeCeremony)
  one.dateTimeDelivery = one.dateTimeDelivery ? new Date(one.dateTimeDelivery) : one.dateTimeDelivery
  one.present = present(one)
  return one
}
getters[pluralName] = state => state.all
getters[`${pluralName}Active`] = state => state.allActive

export default {
  namespaced: true,
  state: {
    ...mapStates(),
    model,
    loading: true,
    all: [],
    allActive: [],
    allFiltered: [],
    statusOptions: statusOptions,
    one: Object.assign({}, model),
    validations: validations,
    count: 0,
    startedOptions: [{ label: 'Selecione um evento', value: '' }],
    ticketsCounter: {},
    lampsCounter: {}
  },
  mutations: {
    ...mapMutations(),
    UPDATE_DEFAULT_MODEL: (state, payload) => {
      for (let field in payload) {
        if (state.model.hasOwnProperty(field)) {
          state.model[field] = payload[field]
        }
      }
    },
    setAllActive: (state, payload) => {
      state.allActive = payload
    },
    setAllFiltered: (state, payload) => {
      state.allFiltered = payload
    },
    setEventsStartedOptions: (state, payload) => {
      state.startedOptions = payload
    },
    setTiketsCount: (state, payload) => {
      state.ticketsCounter = payload.reduce((acc, curr, index) => {
        if (index === 0) {
          acc = {}
        }
        let key = curr.key
        if (!acc.hasOwnProperty(key)) {
          acc[key] = curr.value
        }
        return acc
      }, {})
    },
    SET_LAMPS_COUNT: (state, payload) => {
      state.lampsCounter = payload.reduce((acc, curr, index) => {
        if (index === 0) {
          acc = {}
        }
        let key = curr.key
        if (!acc.hasOwnProperty(key)) {
          acc[key] = curr.value
        }
        return acc
      }, {})
    }
  },
  actions: {
    ...mapActions(collection, model, 'default'),
    fetchAllActive: (context, payload) => {
      context.commit('changeLoading', true)
      Couchdb.collection(collection)
        .where(
          'status',
          statusOptions.iniciado.value
        )
        .all()
        .then(result => {
          context.commit('setAllActive', result)
          context.commit('changeLoading', false)
        })
        .catch(err => {
          console.log(err)
          context.commit('changeLoading', false)
        })
    },
    getStartedEvents: ({ commit }) => {
      commit('changeLoading', true)
      Couchdb.collection(collection)
        .where('status', 1)
        .where('drawn', false)
        .all()
        .then(result => {
          commit('changeLoading', false)
          if (result) {
            let op = []
            for (let r of result) {
              if (r.drawn) {
                continue
              }
              op.push({
                value: r._id,
                label: r.reference
              })
            }

            commit('setEventsStartedOptions', op)
          }
        })
        .catch(err => {
          console.log('err', err)
          commit('changeLoading', false)
        })
    },

    setEventDrawn ({ commit, dispatch }, event) {
      return new Promise((resolve) => {
        Couchdb.connection('default').collection('events')
          .upsert(event._id, event)
          .then((res) => {
            dispatch('fetchOne', event._id)
            dispatch(
              'tickets/fetchTicketsWithCustomersByEvent', {
                where: { surveyAssociated: true },
                eventId: event._id
              },
              { root: true }
            )
            resolve(true)
          })
          .catch(err => {
            console.log('set draw error', err)
            resolve(false)
          })
      })
    },

    setEvent ({ commit }, event) {
      commit('setOne', event)
    },

    filterEventsByTags ({commit, state}, tags) {
      const allEvents = [...state.allFiltered]
      const events = allEvents.filter(event => {
        if (tags.length !== 0) {
          if (event.tags) {
            for (var i = 0, len = tags.length; i < len; i++) {
              if (event.tags.indexOf(tags[i]) === -1) return false
            }
            return true
          }
          return false
        }
        return event
      })
      commit('setAllFiltered', events)
      return events
    },

    filterEventsByDate ({commit, state, dispatch}, {dateRange, tags}) {
      commit('changeLoading', true)
      if (dateRange.length === 0 && verifyEmptyTags(tags)) {
        return dispatch('fetchAll', {limit: 9999})
          .then(res => {
            commit('setAllFiltered', res)
            commit('changeLoading', false)
            return dispatch('filterEventsByTags', tags)
          })
          .catch(err => console.log('fail to fetchAll events', err))
      }

      const where = defineWhereObject(dateRange, tags)
      return Couchdb.where('$and', where['$and'])
        .limit(9999999)
        .all()
        .then(result => {
          commit('setAllFiltered', result)
          commit('changeLoading', false)
          return dispatch('filterEventsByTags', tags)
        })
        .catch(err => {
          console.log(err)
          commit('changeLoading', false)
          return err
        })
    },

    fetchTicketsCount ({ commit }) {
      return Couchdb.connection('default')
        ._viewReduce('events-count-tickets', 'events-count-tickets')
        .then(res => {
          commit('setTiketsCount', res.rows)
          return res
        })
    },

    fetchLampsCount ({ commit }) {
      Couchdb.connection('default')
        ._viewReduce('count-lamps-by-event', 'count-lamps-by-event')
        .then(res => {
          commit('SET_LAMPS_COUNT', res.rows)
        })
    },

    fetchEventsWithSurveys ({ commit }) {
      return Couchdb.collection(collection)
        .where(
          'winnerChoiceMode',
          'ranking'
        )
        .all()
        .catch(err => console.log(err))
        .then(result => {
          commit('setAll', result)
        })
    },

    uploadPhotosEvent (context, {id, mimeType, name, file}) {
      return Couchdb.connection('docs')
        .insertAttachment(id, {
          mimeType: mimeType,
          attachmentName: name,
          attachment: file
        })
    },
    getInsertDocEvent (context, payload) {
      return Couchdb.connection('docs')
        .where('referenceId', payload._id)
        .get()
        .then((res) => {
          if (res.length > 0) {
            return res[0]._id
          }
          return Couchdb.connection('docs')
            .insert({
              'database': 'trg_admin',
              'referenceId': payload._id,
              'collection': 'events'
            })
            .then(res => {
              return res.id
            })
        })
    },
    getURLPhotosEvent (context, payload) {
      return Couchdb.connection('docs')
        .where('referenceId', payload._id)
        .get()
        .then((res) => {
          if (res.length > 0) {
            const baseURL = `${connections.docs.host}/${connections.docs.db}/${res[0]._id}/`
            return Object.keys(res[0]._attachments).filter(res => {
              return res.split('.').pop() === 'jpg'
            }).map(item => {
              return baseURL + item
            })
          }
        })
    }
  },
  getters: {
    ...getters,
    eventPrintLending: state => {
      return state.one.companyTerms === 'cemar' || state.one.companyTerms === 'iasc'
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/events.js